<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR MODELO' : 'NOVO MODELO DE DOCUMENTO'" titleIcon="fas fa-file-alt">
            <el-alert :title="`Use placeholders no formato ${aluno.nome}, ${servidor.nome}, ${instituicao.nome}, ${sistema.data_hoje}, ${sistema.data_extenso}. Eles são substituídos na geração do PDF.`"
                type="info" :closable="false" class="u-mb-15"></el-alert>

            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="form.nome" maxlength="150" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Categoria">
                            <el-select v-model="form.categoria" clearable style="width:100%;">
                                <el-option label="DECLARAÇÃO" value="declaracao"></el-option>
                                <el-option label="ATESTADO" value="atestado"></el-option>
                                <el-option label="COMPROVANTE" value="comprovante"></el-option>
                                <el-option label="LIVRE" value="livre"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="3">
                        <el-form-item label="Papel">
                            <el-select v-model="form.papel" style="width:100%;">
                                <el-option label="A4" value="A4"></el-option>
                                <el-option label="A5" value="A5"></el-option>
                                <el-option label="LETTER" value="Letter"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="3">
                        <el-form-item label="Orientação">
                            <el-select v-model="form.orientacao" style="width:100%;">
                                <el-option label="RETRATO" value="portrait"></el-option>
                                <el-option label="PAISAGEM" value="landscape"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Inserir placeholder">
                    <el-tag v-for="p in placeholdersDisponiveis" :key="p" class="u-mr-5 u-mb-5"
                            style="cursor:pointer;" @click="inserirPlaceholder(p)">
                        {{ marcador(p) }}
                    </el-tag>
                </el-form-item>

                <el-form-item label="Conteúdo (rich text)">
                    <ckeditor v-model="form.conteudo" :config="ckeditorConfig"></ckeditor>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/modelo-documento"><el-button>VOLTAR</el-button></router-link>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
import ckeditor from '@/shared/ckeditor/ckeditor'
const PLACEHOLDERS = [
    'aluno.nome', 'aluno.cpf', 'aluno.rg', 'aluno.data_nascimento', 'aluno.responsavel',
    'aluno.pai', 'aluno.mae',
    'servidor.nome', 'servidor.cpf', 'servidor.matricula',
    'matricula.num_matricula', 'matricula.turma',
    'instituicao.nome', 'instituicao.endereco',
    'sistema.data_hoje', 'sistema.data_extenso', 'sistema.ano'
]
export default {
    components: { ckeditor },
    data () {
        return {
            form: { nome: '', categoria: 'declaracao', orientacao: 'portrait', papel: 'A4', conteudo: '', situacao: true },
            modoEdicao: false,
            placeholdersDisponiveis: PLACEHOLDERS,
            ckeditorConfig: { height: 360 }
        }
    },
    mounted () {
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/modelo-documento/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                Object.keys(this.form).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.form[k] = reg[k] })
            })
        },
        marcador (p) {
            return '{{' + p + '}}'
        },
        inserirPlaceholder (p) {
            const marca = '{{' + p + '}}'
            // CKEditor injeta no cursor; fallback: anexa ao final.
            try {
                const instance = window.CKEDITOR && Object.values(window.CKEDITOR.instances)[0]
                if (instance) {
                    instance.insertText(marca)
                    this.form.conteudo = instance.getData()
                    return
                }
            } catch (e) {}
            this.form.conteudo = (this.form.conteudo || '') + ' ' + marca
        },
        salvar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                const url = this.modoEdicao
                    ? `${this.baseUrl()}/api/modelo-documento/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/modelo-documento/store`
                this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                    this.$router.push('/admin/modelo-documento')
                })
            })
        }
    }
}
</script>
